module.exports = __webpack_public_path__ + "img/screen_size.892aecec.svg";